exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".source-type-explanation{margin-top:10px;font-size:.75rem;color:#767676}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/imaging/ImageSourcePage/index.scss
// module id = 1033
// module chunks = 0